import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

interface LayoutProps {
  children: React.ReactNode;
}

const navItems = [
  { path: '/', icon: 'bi-speedometer2', label: 'Дашборд' },
  { path: '/search', icon: 'bi-search', label: 'Поиск' },
  { path: '/timeline', icon: 'bi-clock-history', label: 'Лента событий' },
  { path: '/segments', icon: 'bi-funnel', label: 'Сегменты' },
  { path: '/favorites', icon: 'bi-star-fill', label: 'Избранное' },
  { path: '/notes', icon: 'bi-journal-text', label: 'Заметки' },
  { path: '/graph', icon: 'bi-diagram-3', label: 'Граф связей' },
  { path: '/actual', icon: 'bi-bank', label: 'Актуальное право' },
  { path: '/topics', icon: 'bi-tags', label: 'Темы' },
  { path: '/rag', icon: 'bi-robot', label: 'AI Ассистент' },
];

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const { user, logout } = useAuthStore();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <>
      {/* Sidebar */}
      <aside className={`sidebar${sidebarOpen ? ' open' : ''}`}>
        <Link to="/" className="sidebar-brand">
          <i className="bi bi-shield-check"></i>
          Право.Монитор
        </Link>
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link${location.pathname === item.path ? ' active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <i className={`bi ${item.icon}`}></i>
              {item.label}
            </Link>
          ))}
          <div style={{ marginTop: 'auto', paddingTop: '16px', borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <Link to="/admin" className="nav-link">
              <i className="bi bi-gear"></i>
              Администрирование
            </Link>
            <button onClick={logout} className="nav-link" style={{ background: 'none', border: 'none', width: '100%', cursor: 'pointer' }}>
              <i className="bi bi-box-arrow-right"></i>
              Выход
            </button>
          </div>
        </nav>
      </aside>

      {/* Main wrapper */}
      <div className="main-wrapper">
        {/* Topbar */}
        <header className="topbar">
          <div className="d-flex align-items-center gap-3">
            <button
              className="btn btn-sm btn-light d-lg-none"
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              <i className="bi bi-list"></i>
            </button>
            <nav aria-label="breadcrumb" className="d-none d-md-block">
              <ol className="breadcrumb mb-0" style={{ fontSize: '14px' }}>
                <li className="breadcrumb-item"><Link to="/" className="text-decoration-none">Главная</Link></li>
                <li className="breadcrumb-item active text-muted">
                  {navItems.find(n => n.path === location.pathname)?.label || 'Страница'}
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div className="text-end">
              <div style={{ fontSize: '14px', fontWeight: 600, color: '#0f172a' }}>{user?.name || 'Гость'}</div>
              <div style={{ fontSize: '12px', color: '#64748b' }}>{user?.email || 'Войдите в систему'}</div>
            </div>
            <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center" style={{ width: 40, height: 40, fontSize: 16, fontWeight: 700 }}>
              {user?.name?.[0] || 'Г'}
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="content-area">
          {children}
        </main>
      </div>
    </>
  );
};
